import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { STORAGE_KEY, PATHS_TO_PERSIST } from '@/constants/storage';

import { getInitialState } from './state';
import { mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

Vue.use(Vuex);

const state = { ...getInitialState() };

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    createPersistedState({
      key: STORAGE_KEY,
      paths: PATHS_TO_PERSIST
    })
  ]
});
